<script lang="ts" setup>
  import { useCssModule } from 'vue';

  defineOptions({
    name: 'll-loading',
  });

  const classes = useCssModule();
</script>

<template>
  <div class="stash-loading flex justify-center py-12" data-test="ll-loading">
    <div class="stash-loading__spinner" :class="classes.spinner">
      <!-- TODO: Load svgs better -->
      <!-- eslint-disable -->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70"><path d="M38,43l-.51.67,0,0-.08.1,0,0-.28.3a3.36,3.36,0,0,1-3.68.6,2.87,2.87,0,0,1-.83-.53l-.08-.07L32.43,44,32.36,44h0l-.07-.07-.06-.08a.83.83,0,0,1-.12-.16l-.06-.08,0-.09a1.62,1.62,0,0,0,.69.16,1.61,1.61,0,0,0,1.09-.43c.45-.43,1.95-2.34,3.13-3.87l1-1.33v4.49a.28.28,0,0,1,0,.09v.11C38,42.78,38,42.87,38,43ZM37,32h0l0,0h0M28,43.13,25,47H21l6.94-9v4.3A4.64,4.64,0,0,0,28,43.13ZM36.72,31.9l-4.26,5.51L32,38V32.66l2.18-2.84a2,2,0,0,0,.26-.39,1.53,1.53,0,0,0-.42-2.1,1.59,1.59,0,0,0-1.31-.18l-.1,0,0,0,.12-.14.13-.14a3,3,0,0,1,4.23,0,2.8,2.8,0,0,1,.46.57c.05.08.09.17.13.25s.08.18.11.27A3,3,0,0,1,38,29.06a4.63,4.63,0,0,1-.1.65,4.82,4.82,0,0,1-1.14,2.15Z" transform="translate(-0.5 -0.5)" style="fill: #676a6c;" /><path d="M37,32l0,0h0m11-3h0a4.63,4.63,0,0,1-.1.65,4.87,4.87,0,0,1-1.16,2.18l-4.28,5.52L42,38V32.65l2.18-2.83a2.65,2.65,0,0,0,.26-.39,1.52,1.52,0,0,0-.43-2.1,1.55,1.55,0,0,0-1.31-.18l-.1,0,0,0,.12-.14.13-.14.11-.1.23-.18.12-.09a3,3,0,0,1,3.77.37A2.91,2.91,0,0,1,48,29.06Zm0,14.85-.41.59,0,0a1,1,0,0,0-.08.11l0,0-.12.15,0,0a1.07,1.07,0,0,1-.14.16,3.23,3.23,0,0,1-4.58.07h0a.46.46,0,0,1-.07-.07,3.31,3.31,0,0,1-.53-.7h0a1.57,1.57,0,0,0,.7.17A1.54,1.54,0,0,0,43.83,44c.23-.24.75-.92,1.55-2Z" transform="translate(-0.5 -0.5)" style="fill: #676a6c;" /><path d="M47.14,26.84a3,3,0,0,0-3.73-.36,3,3,0,0,1,3.09-.11A2.89,2.89,0,0,1,48,29h0A2.86,2.86,0,0,0,47.14,26.84ZM44,44.69a3.39,3.39,0,0,1-.84-.55L43,44.07a3.3,3.3,0,0,1-.52-.65h0a3.34,3.34,0,0,0,.53.66l.07.06h0a3.33,3.33,0,0,0,4.54-.07.64.64,0,0,0,.13-.15l-.14.15A3.31,3.31,0,0,1,44,44.69ZM42.71,27.12l0,0ZM38,42.61v0a3.31,3.31,0,0,0,0,.33C38.05,42.81,38,42.71,38,42.61Zm0-.2c0,.05,0,.1,0,.15V42.5a.28.28,0,0,1,0-.09Zm0,.17v0Zm0-.51v0Z" transform="translate(-0.5 -0.5)" style="fill: #676a6c;" /><path d="M41.17,28.91V42.05a4.38,4.38,0,0,0,0,.52,3.54,3.54,0,0,0,1,2,.76.76,0,0,0,.09.09,3.6,3.6,0,0,0,4,.61,3.8,3.8,0,0,1-.33.37,4.7,4.7,0,0,1-8-2.52,4.88,4.88,0,0,1-.07-.85V28.65A4.68,4.68,0,0,1,42.72,24a4.79,4.79,0,0,1,1.46.23A4.68,4.68,0,0,1,47,26.8l-.17-.18a3.31,3.31,0,0,0-5.53,1.43l0,.12,0,.12A2.6,2.6,0,0,0,41.17,28.91Zm-10,0V42.05a2.94,2.94,0,0,0,.05.51h0a3.53,3.53,0,0,0,1,2l.09.09a3.26,3.26,0,0,0,.91.62,3.59,3.59,0,0,0,3.12,0,3.8,3.8,0,0,1-.33.37,4.69,4.69,0,0,1-7.94-2.51,5,5,0,0,1-.07-.86V28.64A4.68,4.68,0,0,1,32.72,24a4.62,4.62,0,0,1,1.47.24,4.73,4.73,0,0,1,2.2,1.54,4.82,4.82,0,0,1,.61,1,1,1,0,0,0-.17-.18,3.3,3.3,0,0,0-5.52,1.42.69.69,0,0,0,0,.13l0,.12A3.07,3.07,0,0,0,31.16,28.9Z" transform="translate(-0.5 -0.5)" style="fill: #676a6c;" /><path d="M33,28a.08.08,0,0,1,0,0Z" transform="translate(-0.5 -0.5)" style="fill: #676a6c;" /><circle id="circle" cx="35" cy="35" r="32.5" style="fill: none; stroke: #676a6c; stroke-width: 5px;" /></svg>
      <!-- eslint-enable -->
    </div>
  </div>
</template>

<style module>
  @keyframes loading {
    from {
      stroke-dashoffset: 250;
      transform: rotate3d(0, 0, 1, -360deg);
    }

    to {
      stroke-dashoffset: 40;
      transform: rotate3d(0, 0, 1, 0deg);
    }
  }

  .spinner {
    width: 48px;

    svg {
      display: block;
      transform-origin: 50% 50%;
      width: 100%;
    }

    circle {
      animation: loading 1.5s ease-in-out alternate infinite;
      stroke-dasharray: 250;
      transform-origin: center center;
    }
  }
</style>
